<template>
  <div class="terminal-command">
    <span class="terminal-username">{{username}}</span>
    <span class="terminal-prompt" v-html="promptIcon"></span>
    <typer
      @typing-complete="onTypingComplete"
      :text="command"
      :beginTypingDelay="beginTypingDelay"
      :typeCharDelay="typeCharDelay"
      :remainIdle="remainIdle"
    ></typer>
  </div>
</template>
<script>
import Typer from "@/components/typer/Typer";
export default {
  components: { Typer },
  props: {
    username: String,
    promptIcon: { default: " ~ $ " },
    command: String,
    remainIdle: {
      default: false
    },
    typeCharDelay: Number,
    beginTypingDelay: {
      default: 500
    }
  },
  methods: {
    onTypingComplete() {
      this.$emit("command-complete");
    }
  }
};
</script>
